import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20inspiration%20moodboard%20with%20sneakers%20clothing%20swatches%20and%20accessories%20arranged%20on%20textured%20concrete%20surface%2C%20soft%20directional%20window%20light%20from%20left%20creating%20dramatic%20shadows%2C%20contemporary%20European%20editorial%20aesthetic%2C%20warm%20terracotta%20and%20dusty%20rose%20tones%20with%20sage%20green%20accents%2C%20sophisticated%20minimal%20composition%2C%20no%20text%20or%20logos%2C%20magazine%20quality&width=1800&height=1200&seq=hero-bg-main-01&orientation=landscape&nocache=true"
          alt="Itaobuy Spreadsheet fashion collage"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1400px] mx-auto py-32 md:py-40">
        <div className="flex flex-col items-center text-center">
          <span className="text-white/70 text-xs md:text-sm uppercase tracking-[0.25em] mb-6 font-medium">
            Portale Italiano 2026
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight max-w-3xl">
            ITAOBUY
            <br />
            <span className="font-normal italic">SPREADSHEET</span>
          </h1>

          <p className="mt-6 text-white/80 text-base md:text-lg max-w-xl leading-relaxed">
            Il principale hub italiano dedicato alla scoperta dei migliori prodotti dai marketplace cinesi. 
            Guide complete, categorie organizzate e link diretti.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              itaobuy sheet
              <i className="ri-arrow-right-line ml-2 text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 text-sm font-semibold rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-external-link-line ml-2 text-sm"></i>
            </a>
          </div>

          <div className="mt-20 flex flex-col sm:flex-row items-center gap-8 text-white/60 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>Guide Verificate</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>14 Categorie</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>Aggiornato 2026</span>
            </div>
            <Link
              to="/articoli/guida-completa-itaobuy-spreadsheet"
              className="flex items-center gap-1 text-primary-300 hover:text-primary-200 cursor-pointer transition-colors"
            >
              Leggi la Guida Completa
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-xl"></i>
      </div>
    </section>
  );
}